import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    listItemAriaLabel: (name: string) => string;
    advancedSearchItemAriaLabel: (query: string, modifier: string) => string;
    advancedAiSearchItemAriaLabel: (query: string, modifier: string) => string;
    noNameMatchFound: string;
    quickSearchAriaLabel: string;
    resultsListSectionTitle: (count: number) => string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Accessible label for individual search result item */
            listItemAriaLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (name: string): string => __intl__.intl().formatMessage({ id: "QuickSearchCompactContent.listItemAriaLabel?c=112aa0f7ix6vk", defaultMessage: "Search result: {name}" }, { name: name }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessible label for the advanced search item */
            advancedSearchItemAriaLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (query: string, modifier: string): string => __intl__.intl().formatMessage({ id: "QuickSearchCompactContent.advancedSearchItemAriaLabel?c=dbibvwlcn8rs", defaultMessage: "Show all results for {query}, press {modifier} Enter to navigate" }, { query: query, modifier: modifier }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessible label for the AI search item */
            advancedAiSearchItemAriaLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (query: string, modifier: string): string => __intl__.intl().formatMessage({ id: "QuickSearchCompactContent.advancedAiSearchItemAriaLabel?c=2dzavt3qdvk19", defaultMessage: "Show AI results for {query}, press {modifier} Enter to navigate" }, { query: query, modifier: modifier }));
                },
                enumerable: true,
                configurable: true
            },
            /** Message displayed when there are no lexical search results */
            noNameMatchFound: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "QuickSearchCompactContent.noNameMatchFound?c=2co2kulmum4fj", defaultMessage: "No name match found" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessible label for the entire quick search component */
            quickSearchAriaLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "QuickSearchCompactContent.quickSearchAriaLabel?c=3amyyg9z48dnb", defaultMessage: "Quick Search" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Compact results list heading showing how many standard matches were found */
            resultsListSectionTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number): string => __intl__.intl().formatMessage({ id: "QuickSearchCompactContent.resultsListSectionTitle?c=2coao3dvblwkh", defaultMessage: "{count, plural, one {1 result} other {{count} results}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
